export type Create<T extends { id: number | string }> = Omit<T, 'id'>;

export type WithAccount<T> = T & { accountId: number };
